import React from 'react';
import './ShareButton.css';

function ShareButton({ isMobile }) {
    const handleShare = async () => {
        const url = window.location.href;
        const title = 'IceMap - Interactive Map';

        // Try to use native Web Share API if available
        if (navigator.share) {
            try {
                await navigator.share({
                    title: title,
                    url: url,
                });
            } catch (error) {
                // Fallback to clipboard copy
                copyToClipboard(url);
            }
        } else {
            // Fallback to clipboard copy
            copyToClipboard(url);
        }
    };

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            // You could add a toast notification here
            console.log('URL copied to clipboard');
        } catch (error) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            console.log('URL copied to clipboard');
        }
    };

    return (
        <div className={`share-button-container ${isMobile ? 'mobile' : ''}`}>
            <button
                className="share-button"
                onClick={handleShare}
                title="Share this map"
            >
                <svg
                    className="share-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"
                        fill="#ff6600"
                    />
                </svg>
            </button>
        </div>
    );
}

export default ShareButton; 